module.exports = __webpack_public_path__ + "static/img/excel.ad93d624.svg";